import { Injectable } from '@angular/core'

import { ModelRepository  } from './../../../model-repository/model-repository'
import { ModelRepositoryAdapter  } from './../../../model-repository/model-repository-adapter'
import { ActivePath, PathNode } from '../../models'
import { AppContext } from '../../../helpers'
import { Observable } from 'rxjs/Rx'

export class ActivePathService extends ModelRepositoryAdapter<ActivePath> {

  constructor(
    _modelRepository: ModelRepository,
    private _appContext: AppContext
  ) {
    super(_modelRepository, ActivePath)
  }

  public saveActivePath(path: PathNode): Observable<ActivePath> {
    return this.findModelsBy({userId:  this._appContext.currentUser.id}, ['path'])
      .concatMap((currentPaths: ActivePath[]) => {
        const currentPath = currentPaths[0] || this.createModel({userId: this._appContext.currentUser.id })
        if (currentPath.path === path) {
          return Observable.of(currentPath)
        }
        currentPath.path = path
        return this.save(currentPath)
      })
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/active-path/active-path.service.ts